<template lang='pug'>
  transition(name='slide-toggle')
    .alert.notification(:class='notificationClasses' :style='notification.style' role='alert' v-show='showNotification && notification.msg')
      .alert-container
        .alert-message.notification-text
          p.msg(v-text='notification.msg')
          a.link(v-if='notification.link' :href='notification.link.path' v-text='notification.link.text')
        button.close(type='button' data-dismiss='alert' aria-label='Close' @click='closeNotification')
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppNotification',

  data () {
    return {
      interval: {}
    }
  },

  computed: {
    ...mapState({
      notification: state => state.layout.notification,
      showNotification: state => state.layout.showNotification,
      isOffline: state => state.layout.isOffline,
      showSidebar: state => state.layout.showSidebar,
      showAuthPopup: state => state.layout.showAuthPopup
    }),
    isMobile: () => vueSupport.isMobile,
    flash: () => vueSupport.header ? vueSupport.header.flash : {},
    notificationClasses () {
      return [
        ...(this.notification.type ? [`alert-${this.notification.type}`] : ['alert-warning']),
        {
          'with-offline-banner': this.isOffline && !this.showAuthPopup,
          'with-sidebar': this.showSidebar,
          'fixed-top': this.showAuthPopup
        }
      ]
    }
  },

  watch: {
    notification (newAlert) {
      clearTimeout(this.interval)

      if (!newAlert.isSticky) {
        this.interval = setTimeout(() => {
          this.$store.commit('setShowNotification', false)
        }, newAlert.duration || 3500)
      }

      if (newAlert.scrollToTop) {
        this.$scrollTo('#product-index-content', 200, { offset: -80 })
      }
    }
  },

  mounted () {
    if (this.flash) {
      if (this.flash.notice) {
        this.$store.commit('setNotification', {
          type: 'success',
          msg: this.flash.notice
        })
      } else if (this.flash.error) {
        this.$store.commit('setNotification', {
          type: 'error',
          msg: this.flash.error
        })
      } else if (this.flash.alert) {
        this.$store.commit('setNotification', {
          msg: this.flash.alert
        })
      }
    }
  },

  methods: {
    closeNotification () {
      this.$store.commit('setShowNotification', false)
      clearTimeout(this.interval)
    }
  }
}
</script>

<style lang='scss' scoped>
  .slide-toggle-leave-active,
  .slide-toggle-enter-active {
    transition: .7s;
    transform: translate(0, 0);
  }

  .slide-toggle-enter {
    transform: translate(0, -100%);
  }

  .slide-toggle-leave-to {
    transform: translate(0, -100%);
  }

  .notification {
    box-sizing: border-box;
    z-index: $zindex-popover;

    &.fixed-top {
      top: 0;
      z-index: $zindex-popover;
    }

    @include media-breakpoint-down(sm) {
      top: 115px;
      z-index: $zindex-dropdown;

      &:not(.slide-toggle-leave-active):not(.slide-toggle-enter-active) {
        transition: left 0.35s ease;
      }

      &.with-offline-banner {
        top: 115px + $offline-banner-height;
      }

      &.with-sidebar {
        left: $sidebar-offset-left;
      }
    }
  }

  .notification-text {
    width: 100%;
    text-align: center;

    .link {
      text-decoration: underline;
    }
  }

  .alert-dy {
    color: #fff;
    background-color: #C000C4;
  }
</style>
